import { RuleEnum } from '@/constants/enums/RuleEnum';
import { ref } from 'vue';

const patterns = [
  {
    key: RuleEnum.Email,
    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    errorMessage: '信箱格式不正確'
  },
  { key: RuleEnum.Phone, value: /^09\d{8}$/, errorMessage: '手機格式不正確' },
  {
    key: RuleEnum.Name,
    value: /^(?!.*[';]|.*--)[^\s]{2,16}$/,
    errorMessage: '請輸入2~16個字(不包含半型單引號、半型分號、連續兩個半型減號)'
  },
  { key: RuleEnum.VerificationCode, value: /^[\s\S]+$/, errorMessage: '請輸入簡訊驗證碼' }
];

export const useValidator = () => {
  const errorMessage = ref('');

  const handleValidate = (rule: RuleEnum, value: string) => {
    const findItem = patterns.find((item) => item.key === rule);

    if (!findItem) {
      errorMessage.value = '找不到相應格式';
      return false;
    }

    if (!findItem.value.test(value) || value.trim() === '') {
      errorMessage.value = findItem.errorMessage;
      return false;
    }
    return true;
  };

  return {
    errorMessage,
    handleValidate
  };
};
